import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { colors } from '../theme/modernTheme';

export default function TableLoader({ message = 'Loading...' }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        width: '100%',
      }}
    >
      <CircularProgress
        size={48}
        thickness={4}
        sx={{
          color: colors.primary.main,
          mb: 2,
        }}
      />
      <Typography
        variant="body1"
        sx={{
          color: colors.text.secondary,
          fontWeight: 500,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
